import Gallery from "../Gallery";
// import PdfComponent from "../PdfComponent";
// import YouTube from "../Youtube";
import PGImg from "../../../assets/images/p4.jpg"
import rd1 from "../../../assets/images/rd1.jpeg"
import rd2 from "../../../assets/images/rd2.jpg"
import rd3 from "../../../assets/images/rd3.jpg"
import rd4 from "../../../assets/images/rd11.jpeg"
import rd5 from "../../../assets/images/rd5.jpg"
import rd6 from "../../../assets/images/rd6.jpeg"
import rd7 from "../../../assets/images/rd7.jpeg"
import rd8 from "../../../assets/images/rd8.jpeg"
import rd9 from "../../../assets/images/rd9.jpeg"
import rd10 from "../../../assets/images/rd10.jpeg"

const Index = () => {
  return (
    <>
      <article className="post-886 page type-page status-publish hentry category-inclusive-education">
        <div className="page-image focus-point-image">
          <figure className="image image-698">
            <img
              fetchPriority="high"
              loading="lazy"
              style={{ objectPosition: "51.61% 65.34%" }}
              width={2048}
              height={1365}
              src={PGImg}
              srcSet={`${PGImg} 2048w,
                  ${PGImg}  1440w,
                 ${PGImg}    960w
                `}
              alt="Ein Bub sitzt in der ersten Reihe in der Schule und lächelt über sein Heft hinweg in die Kamera. Er trägt eine beigen Fließjacke und ein blaues Hemd."
            />
            <figcaption className>
              Jose Mussena Mozambik 2018 © Ulrich Eigner
            </figcaption>
          </figure>
        </div>
        <div className="content-wrapper-inner">
          <div className="entry-wrap">
            <div className="entry-content pull-up">
              <header>
                <div className="item-title bold-title">
                  <h1 className="entry-title ">Read to Lead Campaign: Fostering a Culture of Literacy and Learning</h1>
                </div>
                <span className="item-date" />
              </header>
              <div className="subnav-mobile">
                <ul className="entry-subnav" />
              </div>
              <section id="readSpeakerSection">
                <section className="paragraph">
                  <div className="paragraph__container">
                    <p>
                      The "Read to Lead" Campaign is an innovative literacy development initiative aimed at improving reading culture,
                      comprehension skills, and language proficiency among children in underserved communities across Nigeria. Through
                      this program, we aim to provide children with access to books, promote storytelling,
                      and integrate ICT tools to make reading engaging, interactive, and more accessible.
                    </p>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container core">
                    <p>
                      <strong>Program Overview: </strong>
                      <br />
                      The "Read to Lead" Campaign focuses on building strong reading habits among children by encouraging daily reading,
                      enhancing comprehension skills, and developing a love for learning. Our goal is to empower children,
                      especially those in rural and underserved areas, with the skills they need to succeed academically and beyond.
                    </p>
                    <p>
                      By providing books, digital resources, and a variety of literacy activities, we are helping children build a strong
                      foundation in language and literacy,
                      preparing them for future educational success and leadership roles.
                    </p>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container core">
                    <p>
                      <strong>Objectives: </strong>
                      <br />
                    </p>
                    <ul className="wp-block-list">
                      <li>
                        <strong> Encourage Daily Reading Habits:</strong> Promote the importance of daily reading, helping children develop regular reading routines that enhance literacy.
                      </li>
                      <li>
                        <strong> Improve Literacy Levels:</strong>   Provide accessible, age-appropriate reading materials to improve language proficiency and comprehension skills
                      </li>
                      <li>
                        <strong>Promote Reading in Local Languages & English: </strong>	 Enhance comprehension by encouraging reading in both local languages and English.
                      </li>
                      <li>
                        <strong>Introduce Digital Reading Resources: </strong>  Expand access to digital resources through tablets, e-books, and ICT-based learning.
                      </li>
                      <li>
                        <strong> Empower Educators and Parents:</strong>	 Equip teachers and parents with the knowledge and tools to support children's reading habits both in school and at home.
                      </li>
                    </ul>
                  </div>
                </section>
                {/* <section className="paragraph">
                  <div className="paragraph__container core">
                    <p>
                      <strong>Collaboration: </strong>
                      <br /> Building partnerships with communities,
                      governments, and other stakeholders.
                    </p>
                  </div>
                </section>{" "} */}
                <section>
                  <h2 className="wp-block-heading core" style={{ fontWeight: "800" }}>Key Components of the Campaign</h2>
                  <strong>"Read to Lead" School Clubs:</strong>
                  <ul className="wp-block-list">
                    <li>Establish reading clubs in primary and secondary schools.</li>
                    <li>Provide free books and digital reading materials.</li>
                    <li>Organize peer reading sessions, storytelling competitions, and book challenges.</li>
                  </ul>
                  <strong>Mobile Literacy Hubs:</strong>
                  <ul className="wp-block-list">
                    <li>
                      Deploy mobile reading vans with books and tablets to rural areas.
                    </li>
                    <li>
                      Set up temporary reading centres in community spaces, mosques, and churches.
                    </li>
                  </ul>

                  <strong>Digital Literacy & E-Library Access:</strong>
                  <ul className="wp-block-list">
                    <li>
                      Provide tablets pre-loaded with e-books in multiple languages.
                    </li>
                    <li>
                      Partner with local internet providers to offer subsidized data plans.
                    </li>
                    <li>
                      Train teachers to integrate digital storytelling and literacy apps into classrooms.
                    </li>
                  </ul>

                  <strong>Reading Competitions & Community Events:</strong>
                  <ul className="wp-block-list">
                    <li>
                      Host annual reading championships with prizes for top performers.
                    </li>
                    <li>
                      Organize "Read Aloud" community events where children read to their peers.
                    </li>
                    <li>
                      Invite local authors and celebrities to read and promote literacy.
                    </li>
                  </ul>

                  <strong>Teacher & Parent Training on Literacy Support:</strong>
                  <ul className="wp-block-list">
                    <li>
                      Train teachers on interactive storytelling techniques.
                    </li>
                    <li>
                      Conduct workshops for parents on supporting reading at home.
                    </li>
                    <li>
                      Provide take-home reading kits for families.
                    </li>
                  </ul>

                </section>
                <section className="paragraph">
                  <div className="paragraph__container core">
                    <p>
                      <strong>Reading Kits for Students: </strong>
                      <br />
                      As part of the "Read to Lead" Campaign, we will provide students with a comprehensive reading kit that includes:
                    </p>
                    <ul className="wp-block-list">
                      <li>
                        A reading bag.
                      </li>
                      <li>
                        A reading journal to track their daily reading progress.
                      </li>
                      <li>
                        Books to encourage a habit of reading.
                      </li>
                    </ul>
                  </div>
                </section>
                <section className="paragraph">
                  <div className="paragraph__container core">
                    <p>
                      In 2026, we aim to distribute 10,000 reading kits across northern states. These kits will help students keep track of how much
                      they've read each month and encourage consistent reading, fostering a culture of literacy in homes and schools.
                    </p>

                  </div>
                </section>
                 <section className="paragraph">
                  <div className="paragraph__container core">
                    <p>
                      <strong>Empowering Future Leaders </strong>
                      <br />
                      Through the "Read to Lead" Campaign, we are not only promoting reading and literacy rdt also empowering students to become future leaders in their communities. By providing children with the tools to succeed,
                       we are helping them unlock their full potential and pave the way for brighter futures in a knowledge-driven world.
                    </p>
                   
                  </div>
                </section>
                {/* gallery  */}
  <Gallery
                  img1={rd1}
                  img2={rd2}
                  img3={rd3}
                  img4={rd4}
                  img5={rd5}
                  img6={rd6}
                  img7={rd7}
                  img8={rd8}
                  img9={rd9}
                  img10={rd10}


                />                 {/* <h4 className="wp-block-heading">
                  More information on Inclusive Education
                </h4> */}
                {/* utube  */}
                {/* <YouTube/> */}
                {/* <h3 className="wp-block-heading">Learn More</h3> */}
                {/* pdf  */}
                {/* <PdfComponent /> */}
              </section>
            </div>
            <aside className="entry-meta">
              <div className="entry-subnav-wrap">
                <ul className="entry-subnav" />
              </div>
            </aside>
          </div>
        </div>
      </article>
    </>
  );
};

export default Index;
